export { SpotOnGameCoreModule } from './spot-on-game-core.module';
export { SpotOnGameSelectorComponent } from './spot-on-game-selector/spot-on-game-selector.component';
export { SpotOnGameCoreService } from './spot-on-game-core.service';
export { ISpotOnGame } from './spot-on-game.interface';
